import {Directive, Input, TemplateRef} from "@angular/core";
import {SearchFormExtendedService} from "./search-form-extended.service";

/**
 * Structural directive used to register the search form input components as templates so they can be added dynamically
 * in the search form. These fields may be hidden from view and included in the "More" multi-select drop down on the
 * search screen.
 *
 * The directive should be provided with an internationalisation translation key which will be used to lookup the
 * label value in drop down list.
 */
export class FieldDescriptor {
    field: string;
    visible: boolean;
}

@Directive({selector: "[extendedField]"})
export class ExtendedSearchInputDirective {
    private _extendedFieldVisible: boolean = true;
    private _field: string;

    constructor(private templateRef: TemplateRef<any>,
                private searchExtendedService: SearchFormExtendedService) {
    }

    @Input() set extendedFieldVisible(visible: boolean) {
        this._extendedFieldVisible = visible;
        if (this._field) {
            if (this._extendedFieldVisible) {
                this.searchExtendedService.registerTemplate(this._field, this.templateRef);
            } else {
                this.searchExtendedService.removeTemplate(this._field);
            }
        }
    }

    @Input() set extendedField(field: string) {
        this._field = field;
        if (this._field && this._extendedFieldVisible) {
            this.searchExtendedService.registerTemplate(this._field, this.templateRef);
        }
    }
}
